export const formatSchema = (content: {
	[key: string]: unknown;
}) => ({
	type: 'application/ld+json',
	innerHTML: content,
});

export const schemaContext = {
	'@context': 'https://schema.org',
};

export const personSchema = (
	name: string,
	jobTitle: string,
	description: string
) =>
	formatSchema({
		...schemaContext,
		'@type': 'Person',
		name,
		jobTitle,
		description,
	});
